export default {
    person: {
        wzTZ: 'Объявление управления закулисьем King Honor',
        wzKF: 'Контактная информация разработчика',
        QQ1: 'QQ No 1',
        QQ2: 'QQ No 2',
        mailbox: 'почтовый ящик',
        browser: 'Обозреватель',
        RecommendedUse: 'Рекомендации по применению',
        mattersNeedingAttention: 'Примечания',
        mattersNeedingAttention1: 'Запрещается модифицировать оригинал и использовать его в коммерческих целях',
        mattersNeedingAttention2: 'Эта страница предназначена только для общения и обучения разработчиков',
        version: 'номер версии',
    },
    home:{
        wzry:"логин",
        game:'логин',
        account:'Пожалуйста, введите номер счета',
        password:'Пожалуйста, введите пароль',
        remember:'Запомните пароль'
    },
    Login:{
        name:"Добро пожаловать",
        register:"зачислять",
        logon:"логин",
        ZY:"Осенний цвет слегка прохладный и темный",
        ReSelect:"Повторный выбор"
    }
};